import { useMemo } from "react";

import Timestamp from "components/Timestamp";
import BadgeNext from "ds/components/BadgeNext";
import Tree, {
  TreeBranch,
  TreeBranchLink,
  TreeItem,
  TreeItemContent,
  TreeItemToggle,
} from "ds/components/Tree";
import Typography from "ds/components/Typography";
import { useToggle } from "hooks/useToggle";
import { RunPolicyReceipt } from "types/generated";
import HistoryEntryPolicy from "components/Run/elements/HistoryEntryPolicy";
import HistoryEntryWrapperSeparator from "components/Run/elements/HistoryEntryWrapper/Separator";

import { getPolicyEvaluation } from "./utils";

type PoliciesProps = {
  policies: RunPolicyReceipt[];
  stackId: string;
  runId: string;
  isModuleRun: boolean;
};

function Policies({ policies, stackId, runId, isModuleRun }: PoliciesProps) {
  const [isOpen, toggle] = useToggle(true);

  const evaluation = useMemo(() => getPolicyEvaluation(policies), [policies]);

  return (
    <TreeBranch>
      <TreeBranchLink>
        <TreeItem padding="small" autoHeight>
          <TreeItemToggle isExpanded={isOpen} onPress={() => toggle()}>
            {isOpen ? "Collapse" : "Expand"}
          </TreeItemToggle>

          <TreeItemContent>
            <Typography variant="p-body3" tag="span" color="secondary">
              Policies evaluated to
            </Typography>

            <BadgeNext
              text={evaluation.label.toUpperCase()}
              variant={evaluation.badgeVariant}
              type="strong"
            />

            <HistoryEntryWrapperSeparator margin="0" />

            <Timestamp color="secondary" timestamp={evaluation.timestamp!} />
          </TreeItemContent>
        </TreeItem>
      </TreeBranchLink>
      {isOpen && (
        <Tree>
          {policies.map((policy) => (
            <HistoryEntryPolicy
              key={policy.id}
              item={policy}
              runId={runId}
              stackId={stackId}
              isModuleRun={isModuleRun}
            />
          ))}
        </Tree>
      )}
    </TreeBranch>
  );
}

export default Policies;
